<rotec-modal-v2 title="Add New Machine Task" width="50vw" height="50vh" darkMode="true">
  <ng-container ngProjectAs="modal-main">
    <div class="tiles">
      <rotec-action-tile-v2
        class="action-tile"
        [darkMode]="true"
        icon="tasks"
        (click)="createNewTask()"
      >
        {{ 'Create New Task' | translate }}
      </rotec-action-tile-v2>
      <rotec-action-tile-v2
        class="action-tile"
        [darkMode]="true"
        icon="upload"
        (click)="uploadTaskList()"
        >{{ 'Upload Task List' | translate }}</rotec-action-tile-v2
      >
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-primary-v2 dark (click)="close()">{{ 'Cancel' | translate }}</button>
  </ng-container>
</rotec-modal-v2>
